import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=ac59d644&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=ac59d644&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac59d644",
  null
  
)

export default component.exports